var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66536 11.8334C5.43334 11.8324 6.17747 11.5666 6.77229 11.0808C7.36712 10.595 7.77624 9.91903 7.9307 9.16675H9.33203V10.5001H10.6654V9.16675H11.9987V11.1667H13.332V9.16675H13.9987V7.83341H7.9307C7.77624 7.08113 7.36712 6.40512 6.77229 5.91935C6.17747 5.43358 5.43334 5.16777 4.66536 5.16675C2.82736 5.16675 1.33203 6.66208 1.33203 8.50008C1.33203 10.3381 2.82736 11.8334 4.66536 11.8334ZM4.66536 6.50008C5.76803 6.50008 6.66536 7.39741 6.66536 8.50008C6.66536 9.60275 5.76803 10.5001 4.66536 10.5001C3.5627 10.5001 2.66536 9.60275 2.66536 8.50008C2.66536 7.39741 3.5627 6.50008 4.66536 6.50008Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIcon);
export default __webpack_public_path__ + "static/media/Assign_icon.79c5268274cc8cac943598c7d4d01c3f.svg";
export { ForwardRef as ReactComponent };